<script lang="ts">
    import IconButton from "@smui/icon-button";
</script>

<span style="opacity: 0.6; position: fixed; top: 80px; right: 0;">
    <IconButton class="material-icons" touch on:click>cancel</IconButton>
</span>